import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dac-range',
  templateUrl: './dac-range.component.html',
  standalone: false
})
export class DACRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
